// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2FyKC","header":"PatientQuestionnaire_header__1e5bm","info":"PatientQuestionnaire_info__2qPH5"};